import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { t, SupportedLocale } from "@/lib/i18n";
import { getWhereToBuyUrl } from "@/lib/urls";
import { HOMEPAGE_PARTNERS } from "@/data/stores";
import { trackAffiliateClick } from "@/lib/analytics";
import styles from "@/styles/Home.module.css";
type WhereToBuySectionProps = {
  locale: SupportedLocale;
};
export function WhereToBuySection(t0) {
  const $ = _c(29);
  const {
    locale
  } = t0;
  let t1;
  if ($[0] !== locale) {
    t1 = t(locale, "home.buyTitle");
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <h2 className={styles.sectionTitle}>{t1}</h2>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== locale) {
    t3 = t(locale, "home.buyBody");
    $[4] = locale;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <p className={styles.sectionSubtitle}>{t3}</p>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className={styles.sectionHeader}>{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== locale) {
    t6 = HOMEPAGE_PARTNERS.map(p => <a key={p.id} href={p.href} target="_blank" rel="nofollow noopener noreferrer" className={styles.buyPartnerLink} title={t(locale, p.labelKey)} onClick={() => trackAffiliateClick({
      partnerId: p.id,
      partnerLabel: t(locale, p.labelKey),
      destinationUrl: p.href,
      context: "homepage"
    })}><img src={p.logoSrc} alt="" className={styles.buyPartnerLogo} aria-hidden={true} /><span className={styles.buyPartnerName}>{t(locale, p.labelKey)}</span></a>);
    $[11] = locale;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <div className={styles.buyPartnersGrid}>{t6}</div>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== locale) {
    t8 = getWhereToBuyUrl(locale);
    $[15] = locale;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== locale) {
    t9 = t(locale, "home.seeMore");
    $[17] = locale;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== locale) {
    t10 = t(locale, "home.seeMore");
    $[19] = locale;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t8 || $[23] !== t9) {
    t11 = <div className={styles.sectionCta}><Link href={t8} className={styles.heroCta} title={t9}>{t10}</Link></div>;
    $[21] = t10;
    $[22] = t8;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t5 || $[27] !== t7) {
    t12 = <section className={styles.sectionBestsellers}><div className={styles.sectionInner}>{t5}{t7}{t11}</div></section>;
    $[25] = t11;
    $[26] = t5;
    $[27] = t7;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}